import { RouterProvider } from 'react-router';
import { initialize, ThemeProvider } from '@blockanalitica/ui';
import router from './router/router';
import { theme, GlobalStyle } from './theme';
import CookieBanner from '@/components/CookieBanner';

initialize({ intl: { timezone: 'UTC' } });

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
      />
      <GlobalStyle />
      <RouterProvider router={router} />
      <CookieBanner />
    </ThemeProvider>
  );
}
